import { useState } from 'react';

import { ChevronRebrandIcon } from './chevron-rebrand';
import { ItemLink } from './item-link';
import styles from '../styles.module.css';

export const Column = ({
  title,
  items,
  websiteUrl,
  locale,
  onFAQClick,
}: {
  title: string;
  items: {
    label: string;
    redirectUrl: string;
    route: {
      path: string;
    };
  }[];
  websiteUrl: string;
  locale: string;
  onFAQClick?: VoidFunction;
}) => {
  const [isColumnCollapsed, setIsColumnCollapsed] = useState<boolean>(false);

  const handleColumnCollapse = () => {
    setIsColumnCollapsed(!isColumnCollapsed);
  };

  return (
    <div className={`${styles.column} ${isColumnCollapsed && styles.columnVisible}`}>
      <button
        type="button"
        className={`${styles.titleColumn} ${styles.buttonReset} ${isColumnCollapsed && styles.titleColumnOpened}`}
        onClick={handleColumnCollapse}
      >
        <span>{title}</span> <ChevronRebrandIcon />
      </button>
      <ul className={`${styles.itemsColumn} ${isColumnCollapsed && styles.itemsColumnVisible}`}>
        {items.map((item) => (
          <li
            key={item.label}
            className={styles.itemColumn}
            onClick={() => {
              if (item.label === 'FAQ') onFAQClick?.();
            }}
          >
            <ItemLink websiteUrl={websiteUrl} {...item} locale={locale} />
          </li>
        ))}
      </ul>
    </div>
  );
};
